var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10336_25394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0C6.68937 0 1.43019 4.49703 0.249145 10.4609H3.85779C4.96968 6.45138 8.6364 3.50391 13 3.50391C15.6232 3.50391 17.9936 4.5698 19.7095 6.29053L15.5391 10.4609H26V0L22.1914 3.80859C19.8391 1.45559 16.5901 0 13 0ZM0 15.5391V26L3.80859 22.1914C6.16083 24.5444 9.40988 26 13 26C19.3106 26 24.5698 21.503 25.7509 15.5391H22.1422C21.0303 19.5486 17.3636 22.4961 13 22.4961C10.3768 22.4961 8.0064 21.4302 6.29053 19.7095L10.4609 15.5391H0Z",
    fill: "#F7C948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10336_25394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadN);
export default __webpack_public_path__ + "static/media/reloadN.03f3c6c441a6e0e0fad5aea99ed257e2.svg";
export { ForwardRef as ReactComponent };